import { render, staticRenderFns } from "./MinDialog.vue?vue&type=template&id=14b87319&scoped=true"
import script from "./MinDialog.vue?vue&type=script&lang=js"
export * from "./MinDialog.vue?vue&type=script&lang=js"
import style0 from "./MinDialog.vue?vue&type=style&index=0&id=14b87319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b87319",
  null
  
)

export default component.exports